module.exports = __webpack_public_path__ + "img/877b11699458922f45e434c8dd4ca014.png";